import { createSlice } from "@reduxjs/toolkit";

const helpinfo=createSlice({
    name:"helpinfo",
    initialState:{flag:0,content:'',id:0,node:null,nodeold:null},
    reducers:{
        setHelpFlag:(state,action)=>{
            state.flag=action.payload
        },
        setHelpNode:(state,action)=>{
            state.node=action.payload
        },
        setHelpContent:(state,action)=>{
            const { flag, content, id, node, nodeold } = action.payload;
            state.flag=flag;
            state.content=content;
            state.id=id;
            state.node=node;
            state.nodeold=nodeold;
        }
    }
});

export const {setHelpFlag,setHelpContent,setHelpNode,setHelpNodeOld}=helpinfo.actions;
export default helpinfo.reducer;